/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as BookingStatus from './trans-website-booking-shared-bookingstatus';

export const BackButton = 'Website.Booking.Shared.BackButton';
export const EditButton = 'Website.Booking.Shared.EditButton';
export const TitleWithPartnerName = 'Website.Booking.Shared.TitleWithPartnerName';
export const BookingUpdatedMessage = 'Website.Booking.Shared.BookingUpdatedMessage';
